var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainContainer"},[_c('ChatContact',{attrs:{"id":this.$route.query.id,"queryLineId":_vm.queryLineId,"disabled":_vm.disabled},on:{"selectedChat":_vm.selectedChat}}),_c('ChatDisplay',{attrs:{"show":_vm.show,"infoProps":_vm.info,"filter":_vm.filter},on:{"loadingHandler":_vm.loadingHandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }